"use client";

import { c as _c } from "react/compiler-runtime";
import PaginatedTable from "@/components/Util/Table/PaginatedTable";
import React, { useMemo, useState } from "react";
import { BusRequest } from "@/types/busrequest";
import { useTranslation } from "@/app/i18n/client";
import { MdPeople } from "react-icons/md";
import { useFilteredBusrequests } from "@/app/[lng]/(mainPages)/buspartner/_components/use-filtered-busrequests";
import { useBusrequestMapContext } from "./busrequestmap-context";
import Tooltip from "@/components/tooltip";
import VacancyTableRow from "./vacancy-table-row";
import GroupRequestTableRow from "./grouprequest-table-row";
export function BusRequestTable({
  openModal
}: {
  openModal: (ids: string[]) => void;
}) {
  const {
    t
  } = useTranslation();
  const filteredRequests = useFilteredBusrequests();
  const {
    typeFilter
  } = useBusrequestMapContext();
  const headers = useMemo(() => {
    return typeFilter?.includes("vacancy") ? [t("MAIN.PAGE_TRAVELCOMPANY.TABLE.HEADERS.vacancy.COL1"), t("MAIN.PAGE_TRAVELCOMPANY.TABLE.HEADERS.vacancy.COL2"), t("MAIN.PAGE_TRAVELCOMPANY.TABLE.HEADERS.vacancy.COL3")] : !!typeFilter ? [t("MAIN.PAGE_TRAVELCOMPANY.TABLE.HEADERS.grouprequest.COL1"), t("MAIN.PAGE_TRAVELCOMPANY.TABLE.HEADERS.grouprequest.COL2"), <div key="participants">
              <Tooltip content={t("MAIN.PAGE_TRAVELCOMPANY.TABLE.HEADERS.grouprequest.COL3")}>
                <MdPeople className="text-secondary" />
              </Tooltip>
            </div>] : [t("MAIN.PAGE_TRAVELCOMPANY.TABLE.HEADERS.grouprequest.COL1"), t("MAIN.PAGE_TRAVELCOMPANY.TABLE.HEADERS.vacancy.COL2") + " / " + t("MAIN.PAGE_TRAVELCOMPANY.TABLE.HEADERS.grouprequest.COL2"), t("MAIN.PAGE_TRAVELCOMPANY.TABLE.HEADERS.vacancy.COL3") + " / " + t("MAIN.PAGE_TRAVELCOMPANY.TABLE.HEADERS.grouprequest.COL3")];
  }, [typeFilter]);
  const [currentPage, setCurrentPage] = useState(1);
  const onlyGrouprequests = useMemo(() => filteredRequests.filter(r => r.category === "grouprequest"), [filteredRequests]);
  const notGrouprequests = useMemo(() => filteredRequests.filter(r_0 => r_0.category !== "grouprequest"), [filteredRequests]);
  const sortedBusRequests = useMemo(() => [...onlyGrouprequests, ...notGrouprequests].sort((a, b) => a.start.date - b.start.date), [onlyGrouprequests, notGrouprequests]);
  return <div className="busrequestTable">
      <PaginatedTable table="Tablev2" items={sortedBusRequests} itemsPerPage={10} currentPage={currentPage} updateCurrentPage={setCurrentPage} alwaysShowPagination className="rounded-b-3xl bg-babyBlue py-4" tableClassName="popRow" headers={headers} headerClasses={["text-center", "text-center", "text-center"]} createTableRow={(item: BusRequest) => <BusRequestTableRow key={item.id} request={item} showDetails={() => {
      openModal([item.id]);
    }} />} />
    </div>;
}
function BusRequestTableRow(props) {
  const $ = _c(6);
  useTranslation();
  if (props.request.category !== "vacancy") {
    let t0;
    if ($[0] !== props.request || $[1] !== props.showDetails) {
      t0 = <GroupRequestTableRow request={props.request} onClick={props.showDetails} />;
      $[0] = props.request;
      $[1] = props.showDetails;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  } else {
    let t0;
    if ($[3] !== props.request || $[4] !== props.showDetails) {
      t0 = <VacancyTableRow request={props.request} onClick={props.showDetails} />;
      $[3] = props.request;
      $[4] = props.showDetails;
      $[5] = t0;
    } else {
      t0 = $[5];
    }
    return t0;
  }
}